import { AuditLayout } from '@/components/layout/audit'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/audit/')({
  component: AuditLogsPage,
  head: () => ({
    meta: [
      { name: 'SUL AI', content: 'SUL AI' },
      { title: 'SUL AI | Audit Logs' },
    ],
  }),
})

function AuditLogsPage() {
  return <AuditLayout />
}
